module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-zoom-0496ebfb1be6ca25cb5096fac3544b2c.png";